import React, { useEffect, useMemo } from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import * as types from '../../reducer/constants';
import { getRefillTypeList } from './helper';
import { getNextRefillCheck } from '../../components/FieldsRefill/helper';
import { getProviderRefillDays } from '../RefillDays/helper';
import { refillTypesList } from './constants';

const FieldRefillType = ({ form, providerForm, dispatchServiceData }) => {
  const { provider_service_id, refill: { refill_type } } = form;
  const { config } = useSelector((state) => state.services);
  const refillTypes = useMemo(() => getRefillTypeList(form, providerForm, config), [config, form, providerForm])

  const onChangeRefillType = (value) => {
    const providerRefillDays = getProviderRefillDays(provider_service_id, providerForm);

    const refillType = value;
    const refillCheck = getNextRefillCheck(refillType);
    const refillDays = providerRefillDays && refillTypesList[refillType]?.value === 1 ? providerRefillDays : null;

    dispatchServiceData({
      type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_TYPE,
      refill_type: refillType,
      refill_check: refillCheck,
      refill_days: refillDays,
    })
  }

  const onChange = (e) => {
    onChangeRefillType(Number(e.target.value))
  };

  useEffect(() => {
    const findRefillType = refillTypes.find((refill) => Number(refill.value) === Number(refill_type))
    if (!findRefillType) {
      const value = Number(refillTypes[0].value);
      onChangeRefillType(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="refill_type">Refill type</ControlLabel>
        <select
          name="refill_type"
          id="refill_type"
          className="form-control"
          value={refill_type}
          onChange={onChange}
        >
          {refillTypes.map((type) => (
            <option
              value={type.value}
              key={type.value}
            >
              {type.name}
            </option>
          ))}
        </select>
      </FormGroup>
    </>
  );
};

FieldRefillType.propTypes = {
  form: PropTypes.object,
  providerForm: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dispatchServiceData: PropTypes.func,
}

export default FieldRefillType;
